var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10307_159471)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70703 4.9987C2.70703 3.73305 3.73305 2.70703 4.9987 2.70703H14.9987C16.2643 2.70703 17.2904 3.73305 17.2904 4.9987V11.2487H16.0404V4.9987C16.0404 4.4234 15.574 3.95703 14.9987 3.95703H4.9987C4.4234 3.95703 3.95703 4.4234 3.95703 4.9987V14.9987C3.95703 15.574 4.4234 16.0404 4.9987 16.0404H11.2487V17.2904H4.9987C3.73304 17.2904 2.70703 16.2643 2.70703 14.9987V4.9987Z",
    fill: "#8A939A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7712 7.31587C14.0153 7.55995 14.0153 7.95568 13.7712 8.19975L9.58397 12.387C9.17718 12.7938 8.51764 12.7938 8.11084 12.387L6.22603 10.5022C5.98195 10.2581 5.98195 9.86242 6.22602 9.61834C6.4701 9.37426 6.86583 9.37425 7.10991 9.61833L8.8474 11.3558L12.8873 7.31587C13.1314 7.07179 13.5271 7.07179 13.7712 7.31587Z",
    fill: "#8A939A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0469 19.9987L16.0469 13.332L17.2969 13.332L17.2969 19.9987L16.0469 19.9987Z",
    fill: "#8A939A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 16.043H20V17.293H13.3333V16.043Z",
    fill: "#8A939A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10307_159471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateTask);
export default __webpack_public_path__ + "static/media/create-task.c660e2b6792ce12ef2ffd462384fdff3.svg";
export { ForwardRef as ReactComponent };